import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-thunder",
  "use": "icon-thunder-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-thunder\"><path d=\"M103.8 181.6l60.1-90.1c2.4-3.5 1.4-8.3-2.1-10.7-1.3-.8-2.8-1.3-4.3-1.3h-47.3V22.7c0-4.3-3.5-7.7-7.7-7.7-2.6 0-5 1.3-6.4 3.4L36 108.5c-2.4 3.5-1.4 8.3 2.1 10.7 1.3.8 2.8 1.3 4.3 1.3h47.3v56.7c0 4.3 3.5 7.7 7.7 7.7 2.6.1 5-1.2 6.4-3.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol